import {
  NumberFormatValues,
  NumericFormatProps,
  NumericFormat as ReactNumericFormat,
} from "react-number-format";

const isAllowed = (values: NumberFormatValues) => {
  const { value } = values;
  if (value[0] && value[1] && value[0] === "0" && value[1] !== ".")
    return false;

  return true;
};

export type NumericInputProps = NumericFormatProps;

export const NumericInput = ({
  className,
  onValueChange,
  ...props
}: NumericInputProps) => {
  return (
    <ReactNumericFormat
      allowNegative={false}
      autoComplete="off"
      className={className}
      isAllowed={isAllowed}
      onValueChange={(values, sourceInfo) => {
        if (sourceInfo.source !== "event") return;
        onValueChange?.(values, sourceInfo);
      }}
      {...props}
    />
  );
};
